import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Update",
  "use": "Update-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Update\"><path fill-rule=\"evenodd\" d=\"M6.49 51.324L1.003 54l2.806-12.495 11.574 5.481-5.216 2.544C15.298 55.914 23.172 60 32 60c15.464 0 28-12.536 28-28S47.464 4 32 4 4 16.536 4 32c0 1.707.153 3.378.445 5H.388A32.24 32.24 0 0 1 0 32C0 14.327 14.327 0 32 0c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32-10.414 0-19.665-4.974-25.51-12.676zM34 33h15a2 2 0 1 1 0 4H32a2 2 0 0 1-1.732-3A1.99 1.99 0 0 1 30 33V21a2 2 0 1 1 4 0v12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol